import React from "react";
import { useModal } from "../../stores/modalStore";
import { BaseModal } from "./BaseModal";
import { AppleIcon } from "../Icons/AppleIcon";
import { ChevronRight } from "lucide-react";
import { AndroidIcon } from "../Icons/AndroidIcon";
import { ANDROID_LINK, TESTFLIGHT_LINK } from "../../constants";

export const DownloadAppModal: React.FC = () => {
  const { closeModal } = useModal();

  return (
    <BaseModal
      isOpen={true}
      onClose={closeModal}
      title="Join HyperApp Alpha Test"
      className="max-w-lg">
      <div className="space-y-4">
        {/* <div>
          We have detected that you are using a{" "}
          <span className="text-primary">{type}</span> device. Please use your
          mobile device to proceed with the HyperApp download.
        </div> */}
        <button
          onClick={() => window.open(TESTFLIGHT_LINK)}
          className="text-left w-full flex justify-between items-center p-3 ring-1 ring-white/10 rounded-2xl hover:ring-primary duration-200 group bg-card">
          <div className="flex items-center gap-x-3">
            <div className="w-20 shrink-0 aspect-square rounded-xl bg-gradient-to-b from-white/10 to-primary/10 flex items-center justify-center">
              <AppleIcon className="w-8 h-8 text-primary" />
            </div>
            <div className="mt-1">
              <div className="text-primary font-semibold tracking-wider text-xxs uppercase">
                Apple iOS
              </div>
              <div className="text-sm sm:text-md font-medium mt-1">
                Download Testflight App
              </div>
              <div className="text-white/50 text-xs">
                Testflight is Apple's beta testing platform
              </div>
            </div>
          </div>
          <ChevronRight className="w-6 h-6 text-white -translate-x-1 group-hover:translate-x-1 duration-200 group-hover:text-primary hidden sm:block" />
        </button>
        <button
          onClick={() => window.open(ANDROID_LINK)}
          className="text-left w-full flex justify-between items-center p-3 ring-1 ring-white/10 rounded-2xl hover:ring-primary duration-200 group bg-card">
          <div className="flex items-center gap-x-3">
            <div className="w-20 shrink-0 aspect-square rounded-xl bg-gradient-to-b from-white/10 to-primary/10 flex items-center justify-center">
              <AndroidIcon className="w-8 h-8 text-primary" />
            </div>
            <div className="mt-1">
              <div className="text-primary font-semibold tracking-wider text-xxs uppercase">
                Android
              </div>
              <div className="text-sm sm:text-md font-medium mt-1">
                Download Playstore App
              </div>
              <div className="text-white/50 text-xs">
                Instantly available on Google Playstore
              </div>
            </div>
          </div>
          <ChevronRight className="w-6 h-6 text-white -translate-x-1 group-hover:translate-x-1 duration-200 group-hover:text-primary hidden sm:block" />
        </button>
      </div>
    </BaseModal>
  );
};
